import React, { useState, useEffect, useRef } from 'react'
import Select from 'react-select';
import { Spinner } from 'reactstrap';

const items = require('../../data/weekdays.json')

const SelectWeekDay = ({
   initialValue = 0,
   setExternalValue,
   isDisabled = false,
   resetValue = false
}) => {
    const isMounted = useRef(true)

    const [loading, setLoading] = useState(true)
    const [value, setValue] = useState(null)

    //Actualizar la referencia
    useEffect(()=>{
        return ()=>{ isMounted.current = false }
    },[])

    //Reset el valor del select
    useEffect(() => {
        const item = items.find( i => i.id === initialValue)
        setValue(item)
    }, [ resetValue ])

    //Cargar el item default
    useEffect(() => {
        if(initialValue != null && isMounted){
            setLoading(true)
            const item = items.find( i => i.id === initialValue)
            setValue(item)
        }
            setLoading(false)
    }, [ initialValue ])

    return (<>
        {
            loading ?  <> <br/><Spinner animation="border" /> </> : <Select
                value={ value }
                options={ items }
                isDisabled={ isDisabled }
                isClearable={ true }
                onChange={ val => {
                    setValue(val)
                    setExternalValue(val?.id)
                } }
            />
        }
    </>)
}

export default SelectWeekDay